const APIList = {
  GET_FAQ: "/mf-central/api/faq/getall",
  CTA_REQUEST_OTP: "/mf-central/api/cta/sendotp",
  CTA_SAVE_DETAILS: "/mf-central/api/cta/save",

  /** Authentication APIs */
  USER_EMAIL_CHECK: "/mf-central/api/user/loginfirst",
  USER_REGISTER: "/mf-central/api/user/register",
  USER_VERIFY_OTP: "/mf-central/api/user/verify",
  USER_RESEND_OTP: "/mf-central/api/user/resendotp",
  USER_LOGOUT: "/mf-central/api/user/logout",
  USER_GET_INFO: "/mf-central/api/user/info",
  USER_GET_CATEGORY : "/mf-central/api/usersCategory/getAll",
  USER_SAVE_GENERAL: "/mf-central/api/user/editInfo",
  USER_BILLING_DETAILS: "/mf-central/api/user/billing/get",
  USER_SAVE_BILLING_DETAILS: "/mf-central/api/user/billing/save",
  USER_AGREEMENTS: "/mf-central/api/user/agreement/getall",
  REFRESH_TOKEN: "/mf-central/api/user/refreshusertoken",

  
  /** Share APIs */
  GET_ALL_USERS: '/mf-central/api/user/api/friends/getall',
  SHARE_TO_USERS: '/mf-central/api/user/api/friends/share',
  DOWNLOAD_POSTMAN_COLLECTION : '/mf-central/api/user/api/download-postman-collection',
  DOWNLOAD_ONBOARDING_DOCUMENT: '/mf-central/api/user/api/downloadDocument',

  /** Profile APIs */
  GET_PROD_USERS: '/mf-central/api/user/prod/user/getall',
  GET_UAT_USERS: '/mf-central/api/user/uat/user/getall',
  POST_UAT_USER: '/mf-central/api/user/uat/create',
  POST_PROD_USER: '/mf-central/api/user/prod/create',
  DELETE_PROD_USER: '/mf-central/api/user/prod/user/delete',
  DELETE_UAT_USER: '/mf-central/api/user/uat/user/delete',
  GET_INVOICES: '/mf-central/api/billManagement/viewInvoices',

  /** API Listing */
  GET_APIS: "/mf-central/api/user/api/getall",
  GET_GROUPS: "/mf-central/api/user/api/searchdata",
  GET_API_BY_ID: "/mf-central/api/user/api/getbyid",
  GET_API_BY_IDS: "/mf-central/api/user/api/getbyids",
  GET_GROUP_BY_ID: "/mf-central/api/user/api/getgroupapis",
  GET_API_BY_VERSION: "/mf-central/api/user/api/getVersion",
  FILTER_BY_CATEGORY: "/mf-central/api/user/api/searchbycategory",
  FILTER_BY_TYPE: "/mf-central/api/user/api/searchbytype",
  GET_USECASE_LIST:"/mf-central/api/user/api/usecase/getbyapiid",
  Get_snippet_data:"/mf-central/api/user/api/snippet/getbylanguageandmethod",

  /** Cart page */
  SET_CART_ITEM: "/mf-central/api/user/api/cart/add",
  REMOVE_CART_ITEM: "/mf-central/api/user/api/cart/remove",
  GET_CART_ITEMS: "/mf-central/api/user/api/cart/getall",
  USER_REGION_CODES: "/mf-central/api/user/region-codes/getAll",


  /** Wishlist */
  ADD_TO_WISHLIST: "/mf-central/api/user/api/wishlist/add",
  REMOVE_FROM_WISHLIST: "/mf-central/api/user/api/wishlist/remove",
  GET_ALL_WISHLIST: '/mf-central/api/user/api/wishlist/getall',

  /** Orders page */
  VALIDATE_CODES: "/mf-central/api/user/api/validatecode",
  POST_ORDER: "/mf-central/api/user/api/order/save",
  GET_ALL_ORDERS: "/mf-central/api/user/api/order/getall",
  GET_ALL_PROD_ORDERS: "/mf-central/api/user/prodapi/order/getall",

  /** Search API */
  SEARCH: "/mf-central/api/user/api/search",

  /** Production APIs + Live APIs */
  GET_ALL_PROD_APIS: "/mf-central/api/user/prodapi/prod/getall",
  GET_FILTERED_PROD_APIS: "/mf-central/api/user/prodapi/filter",
  GET_ALL_LIVE_APIS: "/mf-central/api/user/prodapi/live/getall",

  /** Production cart APIs */
  GET_ALL_PROD_CART_ITEMS: "/mf-central/api/user/prodapi/cart/getall",
  ADD_TO_PROD_CART: "/mf-central/api/user/prodapi/cart/add",
  REMOVE_FROM_PROD_CART: "/mf-central/api/user/prodapi/cart/remove",
  
  /** Production legal formalities / commercials / checkout APIs */
  LEGAL_SIGNOFF: '/mf-central/api/user/prodapi/cart/signoff/save',
  LEGAL_REQUEST: '/mf-central/api/ticket/save',
  SAVE_COMMERCIALS: '/mf-central/api/user/prodapi/cart/commercial/save',
  COMMERCIALS_GETALL_PRICING: '/mf-central/api/user/prodapi/cart/commercial/getall',
  PLACE_PROD_ORDER: '/mf-central/api/user/prodapi/order/save',
  VALIDATE_REFFERAL_CODE: '/mf-central/api/user/prodapi/referral/validate',
  REMOVE_REFFERAL_CODE: '/mf-central/api/user/prodapi/cart/commercial/referral/remove',

  /** Request Support APIs */
  GET_REQUEST_SUPPORT_RECORDS: "/mf-central/api/ticket/getbyuserid",
  GET_REQUEST_SUPPORT_CREATED_BY_LIST: "/mf-central/api/ticket/getuserlist",
  GET_REQUEST_BY_ID: "/mf-central/api/ticket/getbyid",
  POST_REQUEST_COMMENT: "/mf-central/api/ticket/save/comment",

  /** Live APIs track */
  GET_API_USAGE_STATISTICS: "/mf-central/api/user/prodapi/apiStatistics/getStats",
  GET_API_HEALTH_STATISTICS: "/mf-central/api/user/prodapi/apiStatistics/getPieStats",
  GET_API_PERFORMANCE: "/mf-central/api/user/prodapi/apiStatistics/getAPIPerformaceReport",
  GET_PERFORMANCE_REPORT: "/mf-central/api/user/prodapi/apiStatistics/getPerformaceReport",

  // Call CTA 
  // CTA_GETALL: "/mf-central/api/cta-usecase/getallcategory",
  CTA_SEND_OTP: "/mf-central/api/cta-usecase/sendotp",
  CTA_FORM_SAVE: "/mf-central/api/cta-usecase/save",

  //API RAISE REQUEST
  RAISE_REQUEST: "/mf-central/api//ticket/raise-live",
};

export default APIList;
